import { Link } from 'react-router-dom'
import { Section } from '../common/Section'
import { Eyebrow } from '../common/Eyebrow'
import { SplitHeading } from '../animation/SplitHeading'
import { Reveal } from '../animation/Reveal'
import { Icon } from '../common/Icon'
import { company, whatsappLink } from '../../data/company'

const ROUTES = [
  { to: '/contact', icon: 'MessageCircle', title: 'Product enquiry', body: 'Ask about a product, its usage, or which fits your crop.' },
  { to: '/retailer-enquiry', icon: 'Building2', title: 'Become a retailer', body: 'Stock GreenbayBio and serve farmers in your area.' },
  { to: '/distributor-enquiry', icon: 'Handshake', title: 'Become a distributor', body: 'Partner with us to grow the network across regions.' },
]

export function ContactCta() {
  return (
    <Section className="section bg-canvas" containerClassName="">
      <div className="max-w-2xl">
        <Eyebrow>Get in touch</Eyebrow>
        <SplitHeading
          as="h2"
          text="Tell us what you grow — we’ll help you grow it better."
          className="mt-4 font-display text-h1 font-semibold text-ink"
        />
      </div>

      <Reveal className="mt-10 grid gap-4 md:grid-cols-3" stagger={0.12} y={26}>
        {ROUTES.map((r) => (
          <Link
            key={r.to}
            to={r.to}
            className="group flex flex-col rounded-xl border border-sand-200 bg-white p-7 shadow-soft transition-shadow duration-500 hover:shadow-lift"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 text-brand-600">
              <Icon name={r.icon} className="h-6 w-6" />
            </span>
            <h3 className="mt-5 font-display text-xl font-semibold text-ink">{r.title}</h3>
            <p className="mt-2 flex-1 text-[0.95rem] leading-relaxed text-ink-500">{r.body}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600">
              Start enquiry
              <Icon name="ArrowRight" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </Reveal>

      <Reveal className="mt-6 flex flex-wrap items-center gap-x-8 gap-y-3 rounded-xl border border-sand-200 bg-sand-100/50 px-7 py-5 text-sm" y={16}>
        <span className="font-semibold text-ink">Prefer to talk?</span>
        <a href={`tel:${company.phoneHref}`} className="inline-flex items-center gap-2 text-ink-700 hover:text-brand-600">
          <Icon name="Phone" className="h-4 w-4" /> {company.phoneDisplay}
        </a>
        <a href={`mailto:${company.email}`} className="inline-flex items-center gap-2 text-ink-700 hover:text-brand-600">
          <Icon name="Mail" className="h-4 w-4" /> {company.email}
        </a>
        <a
          href={whatsappLink('Hello GreenbayBio, I have an enquiry.')}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-ink-700 hover:text-brand-600"
        >
          <Icon name="MessageCircle" className="h-4 w-4" /> WhatsApp
        </a>
      </Reveal>
    </Section>
  )
}
